import invoiceList from "emun.invoice/invoice-list";
import invoiceListGrid from "emun.invoice/invoice-list-grid";
import invoiceListCards from "emun.invoice/invoice-list-cards";
import invoiceView from "emun.invoice/invoice-view";
import invoiceOneUp from "emun.invoice/invoice-one-up";
import invModule from "emun.invoice/inv/inv.module";
import paymentHistory from "emun.invoice/payment-history";
import creditRequestModule from "emun.invoice/credit-request/credit-request.module";
import { extendModule } from "ng";

const deps = ["emun.auth", "webutils", "webforms", "webmodals", "ui.router"];

export const app = angular
  .module("emun.invoice", deps)
  .component("invoiceList", invoiceList)
  .component("invoiceView", invoiceView)
  .component("invoiceOneUp", invoiceOneUp)
  .directive("invoiceListGrid", invoiceListGrid)
  .component("paymentHistory", paymentHistory)
  .directive("invoiceListCards", invoiceListCards);

extendModule(app, invModule);
extendModule(app, creditRequestModule);

app.config([
  "$provide",
  function($provide) {
    $provide.decorator("$locale", [
      "$delegate",
      function($delegate) {
        if ($delegate.id === "en-us") {
          $delegate.NUMBER_FORMATS.PATTERNS[1].negPre = "(\u00A4";
          $delegate.NUMBER_FORMATS.PATTERNS[1].negSuf = ")";
        }
        return $delegate;
      }
    ]);
  }
]);
export default app.name;
